import React from 'react';
import './styles/style.scss';

const Hr = () => <div className="c-vi-hr" />;

export default Hr;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Hr.jsx